// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"fa02d262","79":"4076fd8d","213":"bce8bc96","512":"2a3599d9","622":"4e84f51d"}[chunkId] + ".chunk.js";
};